import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.support.evaluators');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-support-evaluators',
template: templateSource || '',
    styles: [``],
})
export class PortalLpsysadminSupportEvaluatorsComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public items: any[] = [];
    public loaded: boolean = false;
    public statusFilter: string = '';
    public searchText: string = '';

    public showModal: boolean = false;
    public form: any = this._empty();
    public editingId: string = '';
    public expertiseSelect: string = '';
    public expertiseOptions: string[] = [
        '금융/투자기관',
        '소재/부품/장비',
        'DNA(데이터/네트워크/인공지능)',
        '콘텐츠/플랫폼',
        '에너지/친환경',
        '바이오/메디컬',
        '헬스케어',
        '로봇/모빌리티',
        '소비재',
        '기타'
    ];

    private _empty() {
        return {
            name: '', affiliation: '', position: '',
            email: '', phone: '', expertise: [],
            grade: 'external', note: '', status: 'active'
        };
    }

    private _expertiseArray(value: any): string[] {
        if (Array.isArray(value)) return value.filter((v: any) => !!v);
        if (!value) return [];
        return String(value).split(',').map((v: string) => v.trim()).filter((v: string) => !!v);
    }

    private _requiredMissing(): string[] {
        const required = [
            ['name', '성명'],
            ['grade', '등급'],
            ['affiliation', '소속'],
            ['position', '직책'],
            ['email', '이메일'],
            ['phone', '연락처'],
            ['note', '관리 코멘트'],
            ['status', '상태']
        ];
        const missing = required
            .filter(([key]) => !String(this.form[key] || '').trim())
            .map(([, label]) => label);
        if (this._expertiseArray(this.form.expertise).length === 0) missing.push('전문분야');
        return missing;
    }

    private _payload() {
        const payload = { ...this.form };
        payload.expertise = this._expertiseArray(this.form.expertise).join(', ');
        return payload;
    }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        this.loaded = false;
        await this.service.render();
        const { code, data } = await wiz.call('search', {
            status: this.statusFilter, text: this.searchText
        });
        if (code == 200) {
            this.items = data.rows || [];
        }
        this.loaded = true;
        await this.service.render();
    }

    public openCreate() {
        this.form = this._empty();
        this.expertiseSelect = '';
        this.editingId = '';
        this.showModal = true;
        this.service.render();
    }

    public openEdit(item: any) {
        this.form = { ...item, expertise: this._expertiseArray(item.expertise) };
        this.expertiseSelect = '';
        this.editingId = item.id;
        this.showModal = true;
        this.service.render();
    }

    public closeModal() {
        this.showModal = false;
        this.editingId = '';
        this.service.render();
    }

    public async submit() {
        const missing = this._requiredMissing();
        if (missing.length > 0) {
            this.service.alert.show({ title: '입력 오류', message: `${missing.join(', ')} 항목을 입력하세요.`, action: '확인' });
            return;
        }
        const args: any = { data: JSON.stringify(this._payload()) };
        if (this.editingId) args.id = this.editingId;
        const { code, data } = await wiz.call('upsert', args);
        if (code != 200) {
            this.service.alert.show({ title: '저장 실패', message: data?.message || '오류', action: '확인' });
            return;
        }
        this.showModal = false;
        await this.load();
    }

    public async remove(item: any) {
        const ok = await this.service.alert.show({
            title: '전문가 삭제', message: `"${item.name}" 전문가를 삭제하시겠습니까?`,
            action: '삭제', actionBtn: 'error', cancel: '취소'
        });
        if (!ok) return;
        const { code, data } = await wiz.call('remove', { id: item.id });
        if (code != 200) {
            this.service.alert.show({ title: '삭제 실패', message: data?.message || '오류', action: '확인' });
            return;
        }
        await this.load();
    }

    public gradeLabel(g: string): string {
        return ({ internal: '내부', external: '외부', special: '특별' } as any)[g] || g || '-';
    }

    public expertiseText(value: any): string {
        const list = this._expertiseArray(value);
        return list.length ? list.join(', ') : '-';
    }

    public async addExpertise(item: string) {
        if (!item) return;
        const list = this._expertiseArray(this.form.expertise);
        if (list.includes(item)) {
            this.expertiseSelect = '';
            await this.service.render();
            return;
        }
        if (list.length >= 3) {
            this.expertiseSelect = '';
            await this.service.alert.show({ title: '입력 오류', message: '전문분야는 최대 3개까지 선택할 수 있습니다.', action: '확인' });
            return;
        }
        list.push(item);
        this.form.expertise = list;
        this.expertiseSelect = '';
        await this.service.render();
    }

    public async removeExpertise(item: string) {
        this.form.expertise = this._expertiseArray(this.form.expertise).filter((v: string) => v !== item);
        await this.service.render();
    }
}

export default PortalLpsysadminSupportEvaluatorsComponent;